import styled from 'styled-components'
import {seaNavy, white} from '@modifi/colors'

export const ProgressIndicator = styled.div<{progress: number}>`
  background-color: ${seaNavy};
  width: ${({progress}): string => `${progress}%`};
  height: 1px;
  margin-top: -1px;
  transition: width 0.2s ease;
`

export const TdWithoutPadding = styled.td`
  padding: 0;
`

export const WhiteBackground = styled.div`
  background-color: ${white};
`
